// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { ModuleAdditionalRows } from '../../_contracts';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
import { ListType, TileSize, TileSizeMobile } from '../../_components/Tile';
/**
 * Two-column layout with proper addon support:
 * - Left column (3/4): Uses ThumbnailsListWithAddons for tiles with addons
 * - Right column (1/4): Uses TextListWithAddons for text list with addons
 * This maintains the original design while ensuring consistent addon handling.
 */
let TeaserBoxInnerGridL4STextListTabs = class TeaserBoxInnerGridL4STextListTabs extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
            tiles: {
                0: TileSize.L
            },
            listOffset: 5,
            listType: ListType.LIST
        };
    }
    get tilesOffset() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.addOne:
                return this.gridConfig.listOffset + 3;
            case ModuleAdditionalRows.addTwo:
                return this.gridConfig.listOffset + 6;
            default:
                return this.gridConfig.listOffset;
        }
    }
};
TeaserBoxInnerGridL4STextListTabs.moduleVersion = TeaserBoxVersion['L-4S-text-list-tabs'];
TeaserBoxInnerGridL4STextListTabs = __decorate([
    Component({
        name: 'TeaserBoxInnerGridL4STextListTabs'
    })
], TeaserBoxInnerGridL4STextListTabs);
export { TeaserBoxInnerGridL4STextListTabs };
